import React, {useState, useContext, useEffect} from 'react';
import axios from "axios";
import StepSubscribe from './Steps/StepSubscribe';
import StepWills from './Steps/StepWills';
import {AppContext} from './Context';
import StepDesignation from './Steps/StepDesignation';
import StepSummary from './Steps/StepSummary';
import StepIdentityCard from './Steps/StepIdentityCard';
import StepSignature from './Steps/StepSignature';
import ModalComponent from '../../common-scripts/Helpers/ModalComponent';
import ProgressBar from './ProgressBar';
import SaveForm from '../../common-scripts/Helpers/SaveForm';
import StepWillsOther from "./Steps/StepWillsOther";
import {useIdleTimer} from "react-idle-timer";

const Form = ({homeUrl, progressBarRef, identifier}) => {
	const {
		currentStep,
		steps,
		setdatas,
		setCurrentStep,
		dispatchStepEvent,
		datas,
		scrollToTop,
		setUserIdentifier,
		textsAssistance
	} = useContext(AppContext);

	const handleNextStep = () => {
		dispatchStepEvent('NEXT_STEP');
		scrollToTop();
	};
	const checkReadyForSaving = (state) => {
		setIsStepReadyToSave(state)
	};
	const [isStepReadyToSave, setIsStepReadyToSave] = useState(steps[currentStep].is_ready_for_save)
	const [showSaveModal, setshowSaveModal] = useState(false)

	const [isTimeOut, setIsTimeOut] = useState(false);

	const onPrompt = () => {
		// Fire a Modal Prompt
		// console.log("on prompt")
	}

	const onIdle = () => {
		// Close Modal Prompt
		// Do some idle action like log out your user
		// console.log("on idle")
		//
		setIsTimeOut(true);
	}

	const onActive = (event) => {
		// Close Modal Prompt
		// Do some active action
		// console.log("on active")
	}

	const onAction = (event) => {
		// Do something when a user triggers a watched event

		// console.log("on action")
	}

	const {
		start,
		reset,
		activate,
		pause,
		resume,
		isIdle,
		isPrompted,
		isLeader,
		getTabId,
		getRemainingTime,
		getElapsedTime,
		getLastIdleTime,
		getLastActiveTime,
		getTotalIdleTime,
		getTotalActiveTime
	} = useIdleTimer({
		onPrompt,
		onIdle,
		onActive,
		onAction,
		timeout: 900000,
		promptTimeout: 0,
		events: [
			'mousemove',
			'keydown',
			'wheel',
			'DOMMouseScroll',
			'mousewheel',
			'mousedown',
			'touchstart',
			'touchmove',
			'MSPointerDown',
			'MSPointerMove',
			'visibilitychange'
		],
		immediateEvents: [],
		debounce: 0,
		throttle: 0,
		eventsThrottle: 200,
		element: document,
		startOnMount: true,
		startManually: false,
		stopOnIdle: false,
		crossTab: false,
		name: 'idle-timer',
		syncTimers: 0,
		leaderElection: false
	})


	const handlePrevStep = () => {
		if (currentStep > 0) {
			dispatchStepEvent('PREV_STEP');
			scrollToTop();
		} else {
			dispatchStepEvent('BACK_TO_HOME');
		}
	};

	const showModal = () => {

		if (datas[0].email != '') {
			dispatchStepEvent('SAVE', datas[0].email);
		} else {
			setshowSaveModal(true)
		}
	}

	const onCloseModal = () => {
		setshowSaveModal(false)
	}

	/**
	 * Save Form
	 *
	 * @param {string} userEmail - The user email
	 */
	const saveFrom = (userEmail) => {

		dispatchStepEvent('SAVE', userEmail);
		setShowloader(false);


	}

	useEffect(() => {

		// If identifier defined sync step datas
		if (identifier) {
			axios.get(homeUrl + "/wp-json/gdv/v1/users/" + identifier, {
				headers: {
					"Content-Type": 'application/json',
					"Accept": "application/json"

				}
			}).then((response) => {
				try {

					let data = response.data.data;
					setdatas(data.data);
					dispatchStepEvent('SYNC_STEP_DATA', data.step);
					setUserIdentifier(data.identifier)
					setCurrentStep(data.step);
				} catch (error) {
					console.log(error)
				}


			}).catch((error) => {

				if (error.response.data.code == 404) {

					setCurrentStep(0)

				}

			});

		} else {
			setCurrentStep(0)
		}

	}, [])



	return < >
		<ProgressBar saveForm={showModal} isReadyForSaving={isStepReadyToSave} ref={progressBarRef}/>
		<div className="row center ">

			<div className="col-xs-12 col-lg-4 gutter">

				<div className="card-banner ctas ">
					<span onClick={handlePrevStep} className="back-step"><i className="fa fa-chevron-left"></i>Revenir à l’étape précédente</span>
					{currentStep === 2 && (
						<span onClick={handleNextStep} className={`next-step ${steps[currentStep].is_ready_for_next ? '' : 'wait'}`}>Passer à l'étape suivante<i className="fa fa-arrow-right"></i></span>
					)}

					<span onClick={showModal}
						  className={`bouton bouton-primary bouton-picto  bouton-wire ${!isStepReadyToSave ? "wait" : ""}`}><i
						className="fa fa-save" aria-hidden="true"></i>Sauvegarder et quitter</span>
				</div>
				<div className="assistance-banner">
					<h2>{textsAssistance.title}</h2>
					<a href={textsAssistance.ctaUrl} title="Appelez-nous"
					   className="bouton bouton-full bouton-business bouton-picto">
						<span className="arrow"><i className="fa fa-phone"></i></span><span
						className="text">{textsAssistance.ctaLabel}</span>
					</a>
					<p>
						{textsAssistance.numPhoneText} <br/>
						<span>{textsAssistance.subText}</span> <br/>
						<span className="business-info">{textsAssistance.subText2}</span> <br/>
					</p>

				</div>
			</div>
			<div className="col-xs-12 col-lg-8">


				{currentStep == 0 &&
					<StepSubscribe checkReadyForSaving={checkReadyForSaving}
								   userData={datas.length > 0 ? datas[0] : null}
								   texteInfos={steps[currentStep].text}/>}


				{
					currentStep == 1 &&
					<StepWills checkReadyForSaving={checkReadyForSaving}
							   userData={datas.length > 0 ? datas[1] : null}
							   texteInfos={steps[currentStep].text}/>
				}
				{
					currentStep == 2 && (
						<StepWillsOther
							checkReadyForSaving={checkReadyForSaving}
							userData={datas.length > 0 ? datas[1] : null}
							texteInfos={steps[currentStep].text}
						/>
					)
				}
				{
					currentStep == 3 &&
					<StepDesignation checkReadyForSaving={checkReadyForSaving}
									 userData={datas.length > 0 ? datas[2] : null}
									 texteInfos={steps[currentStep].text}/>
				}
				{
					currentStep == 4 &&
					<StepSummary checkReadyForSaving={checkReadyForSaving}
								 userData={datas.length > 0 ? datas[4] : null}
								 texteGeneralConditions={steps[4].text}
								 texteInfos={steps[5].text}/>
				}
				{
					currentStep == 5 &&
					<StepIdentityCard checkReadyForSaving={checkReadyForSaving}
									  userData={datas.length > 0 ? datas[5] : null}
									  texteInfos={steps[6].text}/>
				}
				{
					currentStep == 6 &&
					<StepSignature texteInfos={steps[6].text}/>
				}


				{currentStep < 4 && <div className="bottom">

					<div className="prev_next stepper">
						<div id="prev_mobile">
							<button onClick={showModal}
									className={`bouton-picto-left goto_backto ${!isStepReadyToSave ? "wait" : "ready"}`}>
								<i className="fa fa-save"></i>Sauvegarder et quitter
							</button>
						</div>
						<div>
							<button onClick={handleNextStep}
									className={`bouton bouton-full bouton-business bouton-picto-r goto_backto ${!steps[currentStep].is_ready_for_next ? "wait" : "ready"}`}>
								<span>Poursuivre</span> <i className="fun-picto fun-picto-arrow-right"></i></button>
						</div>

					</div>
				</div>}


			</div>
		</div>

		{isTimeOut && <ModalComponent
			showModal={true}
			content={
				(
					<div style={{minWidth:'394px',padding:'10px',margin:'10px',textAlign:'center',display:'table-caption'}}>
						<div className={"form-card"}>
							<p><strong>Votre session est inactive depuis plusieurs minutes.</strong></ p>
							<p><strong>Vous souhaitez ? </strong></p>

							<div style={{display: 'flex', flexDirection: 'column'}}>
								<button
									// className={"bouton bouton-primary bouton-wire"}
									className={"bouton bouton-full bouton-business"}
									type={"button"}
									style={{
										margin: '10px'
									}}
									onClick={() => {

										setIsTimeOut(false);

									}}
								>
									Poursuivre votre saisie
								</button>

								<button type={"button"} style={{
									margin: '10px'
								}} className="bouton bouton-primary bouton-picto bouton-wire" onClick={() => {
									if (datas[0].email !== '') {
										dispatchStepEvent('SAVE', datas[0].email);
									} else {
										setshowSaveModal(true)
									}
								}}>
									<i  className="fa fa-save" aria-hidden="true" ></i>
									Sauvegarder et quitter
								</button>

								<button
									className={"bouton bouton-full bouton-business"}
									style={{
										margin: '10px'
									}}
									type={"button"}
									onClick={() => {
										window.location.href = homeUrl;
									}}
								>
									Quitter
								</button>

							</div>
						</div>
					</div>
				)
			}
		/>}

		{showSaveModal &&
			<ModalComponent showModal={showModal} onClose={onCloseModal} content={<SaveForm OnSaveFrom={saveFrom}/>}/>}


	</>;
};

export default Form;
